import { Injectable } from '@angular/core';

// Service
import { NetworkService } from '../../infrastructure/network.service';
import { ConfigService } from '../../infrastructure/config.service';
import { saveAs } from 'file-saver';
import { BranchPlantVM } from '../../../models/ShippingAvailability/BranchPlantVM';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShippingAvailabilityService {
  public SelectedBranchPlantList: BehaviorSubject<Array<BranchPlantVM>>;
  constructor(private configService: ConfigService,
    private networkService: NetworkService) {
    this.SelectedBranchPlantList = new BehaviorSubject<Array<BranchPlantVM>>([]);
  }

  public setSelectedBranchPlantList(value: Array<BranchPlantVM>) {
    this.SelectedBranchPlantList.next(value);
  }

  // Get State List for filter dropdown
  public getAvailabilityReportData(filters) {
    return this.networkService.postRequest(this.configService.getShippingAvailabilityReportUrl, filters);
  }

  // Email Product Availability List
  public emailProductAvailabilityList(data) {
    return this.networkService.postRequest(this.configService.sendProductAvailabilityEmail(), data);
  }

  public exportProductAvailabilityList(data) {
    return this.networkService.postRequest(this.configService.exportProductAvailabilityList(), data);
  }

  public base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }

  // Convert b64 to BLOB
  public b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
